export default __webpack_public_path__ + "images/information.v-5e435023f1ca8eda5c85a1687780f5eb.svg";